/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SqlQueryExecutionResultColumn } from '../models/SqlQueryExecutionResultColumn';

export class SqlQueryExecutionResult {
  /**
  * The ID of the query execution
  */
  'queryExecutionId': string;
  /**
  * The column definitions of the result
  */
  'columns': Array<SqlQueryExecutionResultColumn>;
  /**
  * The rows of the result, each row is an array of values
  */
  'rows': Array<Array<any>>;
  /**
  * Token for fetching the next page of results
  */
  'nextToken'?: string | null;
  /**
  * Total number of rows in the full result set
  */
  'totalRowCount'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "queryExecutionId",
      "baseName": "queryExecutionId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "columns",
      "baseName": "columns",
      "type": "Array<SqlQueryExecutionResultColumn>",
      "format": ""
    },
    {
      "name": "rows",
      "baseName": "rows",
      "type": "Array<Array<any>>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalRowCount",
      "baseName": "totalRowCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SqlQueryExecutionResult.attributeTypeMap;
  }

  public constructor() {
  }
}

